import { __awaiter, __extends, __generator } from "tslib";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Composites, TextLabel, ActionWithSymbol, } from '@wix/wix-base-ui';
import { getFontDisplayName } from '../FontAndColorPicker/BaseFontAndColorPicker';
import { FontPickerIcon } from '../FontAndColorPicker/FontPickerIcon';
import { openFontPicker } from '../FontAndColorPicker/openFontPicker';
var BaseFontPicker = /** @class */ (function (_super) {
    __extends(BaseFontPicker, _super);
    function BaseFontPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFontPickerRef = function (ref) {
            _this.fontPickerRef = ref;
        };
        _this.handleOpenFontPicker = function () {
            var _a = _this.props, SDKAdapter = _a.SDKAdapter, font = _a.font, fontPickerTitle = _a.fontPickerTitle, fontPickerOptions = _a.fontPickerOptions, onFontChange = _a.onFontChange;
            var position = _this.getFontPickerPositionOfPicker();
            openFontPicker(SDKAdapter, {
                font: font,
                fontPickerTitle: fontPickerTitle,
                fontPickerOptions: fontPickerOptions,
                onFontChange: onFontChange,
                position: position,
            });
        };
        _this.state = {
            presets: null,
        };
        return _this;
    }
    BaseFontPicker.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, this.props.SDKAdapter.getSiteTextPresets()];
                    case 1:
                        _a.apply(this, [(_b.presets = _c.sent(),
                                _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseFontPicker.prototype.getFontPickerPositionOfPicker = function () {
        var dom = ReactDOM.findDOMNode(this.fontPickerRef);
        return dom.getBoundingClientRect();
    };
    BaseFontPicker.prototype.render = function () {
        var _a = this.props, dataHook = _a.dataHook, label = _a.label, font = _a.font, _b = _a.customFontLabel, customFontLabel = _b === void 0 ? 'Custom' : _b;
        return (React.createElement("div", { "data-aid": dataHook, "data-hook": dataHook },
            React.createElement(Composites.ActionWithSymbolLabeled, { automationId: "font-picker" },
                React.createElement(TextLabel, { value: label, automationId: "label" }),
                React.createElement("span", { style: { paddingBottom: '5px', display: 'block' } }),
                React.createElement(ActionWithSymbol, { action: this.handleOpenFontPicker, symbol: React.createElement(FontPickerIcon, null), ref: this.handleFontPickerRef },
                    React.createElement("label", { "data-aid": "font-label" }, getFontDisplayName(this.state.presets, font.preset, customFontLabel))))));
    };
    return BaseFontPicker;
}(React.Component));
export { BaseFontPicker };
//# sourceMappingURL=BaseFontPicker.js.map